import { getResponse } from '@satellite/services/serviceUtilities';

/**
 * Neutron metrics-v2 API client (insights reporting tables).
 */
export default {
  /**
   * @param {Record<string, unknown>} body - Asset visit metrics list query (DTO shape)
   * @param {import('@satellite/services/serviceUtilities').GetResponseConfig} [options]
   * @param {import('axios').AxiosRequestConfig} [requestConfig]
   * @returns {Promise<{ total?: number; results?: unknown[] }>}
   */
  async postAssetVisitMetricsList(body, options = {}, requestConfig = {}) {
    const response = await axios.post('/metrics-v2/asset-visits', body, requestConfig);
    return getResponse(response, options);
  },

  /**
   * @param {Record<string, unknown>} body - Asset visit Excel export (AssetVisitExcelExportDto)
   * @param {import('@satellite/services/serviceUtilities').GetResponseConfig} [options]
   * @param {import('axios').AxiosRequestConfig} [requestConfig]
   * @returns {Promise<{ url?: string; key?: string } | Record<string, unknown>>}
   */
  async postAssetVisitExcelExport(body, options = {}, requestConfig = {}) {
    const response = await axios.post('/metrics/asset-visits/excel', body, requestConfig);
    return getResponse(response, options);
  }
};
